import { render, staticRenderFns } from "./ContentViewSettingsHeader.vue?vue&type=template&id=f122f892&scoped=true&"
import script from "./ContentViewSettingsHeader.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsHeader.vue?vue&type=style&index=0&id=f122f892&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f122f892",
  null
  
)

export default component.exports